import { render } from "./AssignmentOverridesList.vue?vue&type=template&id=369868d0"
import script from "./AssignmentOverridesList.vue?vue&type=script&lang=js"
export * from "./AssignmentOverridesList.vue?vue&type=script&lang=js"

import "./AssignmentOverridesList.vue?vue&type=style&index=0&id=369868d0&lang=css"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "369868d0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('369868d0', script)) {
    api.reload('369868d0', script)
  }
  
  module.hot.accept("./AssignmentOverridesList.vue?vue&type=template&id=369868d0", () => {
    api.rerender('369868d0', render)
  })

}

script.__file = "src/components/AssignmentOverridesList.vue"

export default script